
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about-careers",
      function () {
        return require("private-next-pages/about-careers/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about-careers"])
      });
    }
  